import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHttp, SCHEMA_VERSION } from '@core/api/api-http';
import { OpportunityApiHttp } from '@core/api/opportunity-api-http';
import { environment } from '@env/environment';
import { AuditLogEvent, EntityType } from '../models/audit-log';

@Injectable({
  providedIn: 'root'
})
export class AuditService {
  constructor(
    private opportunityHttp: OpportunityApiHttp,
    private http: ApiHttp
  ) {}

  getAuditLog(entityType: EntityType, entityId: string): Observable<AuditLogEvent[]> {
    const config = this.getHttpConfig(entityType, entityId);
    
    switch (entityType) {
      case EntityType.OPPORTUNITY:
        return this.opportunityHttp.get<AuditLogEvent[]>(config.endpoint, ApiHttp.getStandardOptions());
      case EntityType.LEAD:
        return this.http.getEntity<AuditLogEvent[]>(environment.clientsApiUrl, config.endpoint, config.schemaVersion, ApiHttp.getStandardOptions());
      case EntityType.INDIVIDUAL:
        return this.http.getEntity<AuditLogEvent[]>(environment.clientsApiUrl, config.endpoint, config.schemaVersion, ApiHttp.getStandardOptions());
      case EntityType.COMPANY:
        return this.http.getEntity<AuditLogEvent[]>(environment.clientsApiUrl, config.endpoint, config.schemaVersion, ApiHttp.getStandardOptions());
      case EntityType.TRUST:
        return this.http.getEntity<AuditLogEvent[]>(environment.clientsApiUrl, config.endpoint, config.schemaVersion, ApiHttp.getStandardOptions());
    }
  }

  private getHttpConfig(entityType: EntityType, entityId: string):
    | { httpClient: OpportunityApiHttp; endpoint: string; schemaVersion: number }
    | { httpClient: ApiHttp; endpoint: string; schemaVersion: number } {
    switch (entityType) {
      case EntityType.OPPORTUNITY:
        return {
          httpClient: this.opportunityHttp,
          endpoint: `opportunities/${entityId}/audit-log`,
          schemaVersion: SCHEMA_VERSION.OPPORTUNITY
        };
      case EntityType.LEAD:
        return {
          httpClient: this.http,
          endpoint: `leads/${entityId}/audit-log`,
          schemaVersion: SCHEMA_VERSION.LEAD
        };
      case EntityType.INDIVIDUAL:
        return {
          httpClient: this.http,
          endpoint: `individuals/${entityId}/audit-log`,
          schemaVersion: SCHEMA_VERSION.INDIVIDUAL
        };
      case EntityType.COMPANY:
        return {
          httpClient: this.http,
          endpoint: `companies/${entityId}/audit-log`,
          schemaVersion: SCHEMA_VERSION.COMPANY
        };
      case EntityType.TRUST:
        return {
          httpClient: this.http,
          endpoint: `trusts/${entityId}/audit-log`,
          schemaVersion: SCHEMA_VERSION.TRUST
        };
      default:
        throw new Error(`Unsupported entity type: ${entityType}`);
    }
  }
} 